/** @typedef {'square' | 'landscape' | 'portrait'} CropMode */

export const CROP_MODES = {
  square: {
    label: 'Square',
    aspect: 1,
    outWidth: 1024,
    outHeight: 1024,
    openAiSize: '1024x1024',
  },
  landscape: {
    label: 'Landscape',
    aspect: 3 / 2,
    outWidth: 1536,
    outHeight: 1024,
    openAiSize: '1536x1024',
  },
  portrait: {
    label: 'Portrait',
    aspect: 2 / 3,
    outWidth: 1024,
    outHeight: 1536,
    openAiSize: '1024x1536',
  },
};

/** @type {CropMode[]} */
export const CROP_MODE_KEYS = ['square', 'landscape', 'portrait'];

/**
 * @param {number} width
 * @param {number} height
 * @returns {CropMode}
 */
export function defaultCropModeFromDimensions(width, height) {
  if (!width || !height) return 'square';
  const r = width / height;
  if (r > 1.2) return 'landscape';
  if (r < 0.83) return 'portrait';
  return 'square';
}

/**
 * @param {string} [openAiSize]
 * @returns {(typeof CROP_MODES)[CropMode]}
 */
export function cropConfigFromOpenAiSize(openAiSize) {
  const match = Object.values(CROP_MODES).find((mode) => mode.openAiSize === openAiSize);
  return match || CROP_MODES.landscape;
}

/**
 * @param {string} [openAiSize]
 * @returns {CropMode}
 */
export function cropModeKeyFromOpenAiSize(openAiSize) {
  const match = Object.entries(CROP_MODES).find(([, mode]) => mode.openAiSize === openAiSize);
  return match ? match[0] : 'landscape';
}

